import React, { Component } from "react";
import { connect } from "react-redux";

class FooterText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showText: true
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (
        this.props.ropeEndControl.orderCode === "15" &&
        this.props.fasteners.orderCode === "1" &&
        this.props.externalBrakeRelease.orderCode === "1" &&
        this.props.throttleValve.orderCode === "1"
      ) {
        this.setState({
          showText: false
        });
      }
    }
  }

  render() {
    return (
      <div className="text-wrapper">
        {this.state.showText && (
          <p>
            In case your TITAN hoisting winch needs to be suitable for API 2C
            certified devices, you need to select the options rope end control
            activated with 5 windings, stainless steel fasteners, external brake
            release and brake test valve. If that is needed, please revisit your
            selections.
          </p>
        )}
        {!this.state.showText && <br />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ropeEndControl: state.ropeEndControl,
    fasteners: state.fasteners,
    externalBrakeRelease: state.externalBrakeRelease,
    throttleValve: state.throttleValve
  };
};

export default connect(mapStateToProps)(FooterText);



// WEBPACK FOOTER //
// ./src/components/footerText.js